<template>
<w-sliding-popup title="실시간 제어" ref="realtimeControlSlidingPopup" width="1100px">
  <div slot="content" style="height: 100%">
    <div class="mr-b25" style="height: 50%">
      <el-row type="flex" class="title-bar" justify="space-between">
        <div class="title-h4 dot-title">중요 프로세스 목록</div>
        <div>
          <w-header-search-button @click="majorShowSearchTool = !majorShowSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper :data="majorDatas" :columns="majorColumns" :show-custom-header="true" :show-search-tool="majorShowSearchTool" :pagination="true"
      :column-default="columnDefault" ref="majorTable">
        <template slot-scope="scope" slot="status-slot">
          <span v-if="scope.row['procStatus'] != null" :class="getStatusAliveClass(scope.row['procStatus'])">{{statusAliveFormatter(scope.row['procStatus'])}}</span>
          <el-tooltip v-else effect="dark" content="자원 미수집" placement="top"><span> - </span></el-tooltip>
        </template>
        <template slot-scope="scope" slot="cpu-slot">
          <el-progress v-if="scope.row.procCpuUserate > 0" :class="progressbarBgcolor(scope.row.procCpuUserate)" :text-inside="true" :stroke-width="18" :percentage="scope.row.procCpuUserate"></el-progress>
          <el-progress v-else :text-inside="true" :stroke-width="18" :percentage="0"></el-progress>
        </template>
        <template slot-scope="scope" slot="memory-slot">
          <span :style="`color: ${memoryTextColor(scope.row.procMemUsedsize)}`">{{getConvertValuByUnit(scope.row.procMemUsedsize)}}</span>
        </template>
        <template slot-scope="scope" slot="process-control-slot">
          <div v-show="scope.row['procStatus'] === '0'">
            <el-button v-if="isProcessCommand(scope.row.processCommandStart)" type="text" @click="onClickExecuteServerStartMajorProcess(scope.row)">시작</el-button>
            <el-tooltip v-else effect="dark" content="시작 명령어가 없습니다." placement="top"><span> - </span></el-tooltip>
          </div>
          <div v-show="scope.row['procStatus'] === '1'">
            <el-button v-if="isProcessCommand(scope.row.processCommandStop)" type="text" @click="onClickExecuteServerStopMajorProcess(scope.row)">중지</el-button>
            <el-tooltip v-else effect="dark" content="종료 명령어가 없습니다." placement="top"><span> - </span></el-tooltip>
          </div>
          <div v-show="scope.row['procStatus'] === null">
            <el-tooltip effect="dark" content="수집정보가 없습니다." placement="top"><span> - </span></el-tooltip>
          </div>
        </template>
      </el-table-wrapper>
    </div>
    <div style="height: 50%" v-loading="loading">
      <el-row type="flex" class="title-bar" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4 dot-title">프로세스 목록</div>
          <div class="mr-l15">
            <el-button size="small" type="secondary" :disabled="!isProcDeleted" @click="killProcess()">프로세스 종료</el-button>
          </div>
        </div>
        <div>
          <el-checkbox-group class="inline cmp-margin-right" v-model="processCheckBoxChecked">
            <el-checkbox label="procTotalCount" @change="onChangeProcessCheckBox('procTotalCount')">전체</el-checkbox>
            <el-checkbox label="procZombieCount" @change="onChangeProcessCheckBox('procZombieCount')">좀비 프로세스</el-checkbox>
          </el-checkbox-group>
          <w-oligopoly-popover-button class="inline" @formSubMit="onFormSubmitPopoverOligopoly" />
          <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper :data="tableList" :columns="columns" :row-class-name="processMajorBgcolor" :show-custom-header="true" :show-search-tool="showSearchTool" :pagination="true"
      :column-default="columnDefault" @selection-change="procChangeSelection" style="width:100%;">
        <template slot-scope="scope" slot="cpu-slot">
          <el-progress v-if="scope.row.procCpuUserate > 0" :class="progressbarBgcolor(scope.row.procCpuUserate)" :text-inside="true" :stroke-width="18" :percentage="scope.row.procCpuUserate"></el-progress>
          <el-progress v-else :text-inside="true" :stroke-width="18" :percentage="0"></el-progress>
        </template>
        <template slot-scope="scope" slot="memory-slot">
          <span :style="`color: ${memoryTextColor(scope.row.procMemUsedsize)}`">{{getConvertValuByUnit(scope.row.procMemUsedsize)}}</span>
        </template>
      </el-table-wrapper>
    </div>
  </div>
</w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import { isTrue } from '@/utils/boolean';
import serverTableInfoAPI from '@/api/performance/server/info-table';
import { columnDefault } from '@/constants/table';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { mapGetters } from 'vuex';
import { convertValuByUnit } from '@/utils/number';
import WOligopolyPopoverButton from '@/views/performance/node/analysis/server/components/button/OligopolyPopoverButton';

export default {
  name: 'WServerRealtimeControlPopup',
  components: {
    WOligopolyPopoverButton,
  },
  data() {
    return {
      loading: false,
      showSearchTool: false,
      majorShowSearchTool: false,
      majorDatas: [],
      totalDatas: [],
      zombieList: [],
      procChangeList: [],
      isProcDeleted: false,
      majorTotal: 0,
      columnDefault,
      processCheckBoxChecked: ['procTotalCount'],
      popoverOligopolyForm: {},
      majorColumns: [
        { prop: 'procStatus', label: '동작상태', width: 70, sortable: true, scopedSlot: 'status-slot' },
        { prop: 'processId', label: '프로세스 ID', width: 130, remoteProp: 'smp.process_id', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty, showOverflowTooltip: true },
        { prop: 'procName', label: '프로세스명', remoteProp: 'smp.process_name', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty, showOverflowTooltip: true },
        { prop: 'procCount', label: '동작개수', width: 70, sortable: true, formatter: this.formatterForProcCount },
        { prop: 'procCpuUserate', label: 'CPU (%)', width: 120, sortable: true, scopedSlot: 'cpu-slot' },
        { prop: 'procMemUsedsize', label: '메모리', width: 80, sortable: true, scopedSlot: 'memory-slot' },
        { label: '제어', width: '70px', scopedSlot: 'process-control-slot' },
      ],
      columns: [
        { align: 'center', type: 'selection' },
        { prop: 'procUid', label: '소유자', width: 100, sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'procPid', label: 'PID', width: 70, sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty, showOverflowTooltip: true },
        { prop: 'procPpid', label: 'PPID', width: 70, sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'procName', label: '프로세스명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty, showOverflowTooltip: true },
        { prop: 'procCpuUserate', label: 'CPU (%)', width: 120, sortable: true, scopedSlot: 'cpu-slot' },
        { prop: 'procMemUsedsize', label: '메모리', width: 80, sortable: true, scopedSlot: 'memory-slot' },
        { prop: 'procCputime', label: 'CPU 시간', width: 82, sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'procPri', label: '우선순위', width: 82, sortable: true, formatter: this.getTableValueAfterCheckEmpty },
      ],
    };
  },
  computed: {
    tableList() {
      if (this.processCheckBoxChecked[0] === 'procZombieCount') {
        return this.zombieList;
      }
      return this.totalDatas;
    },
    ...mapGetters(['selectedNode']),
  },
  watch: {
    procChangeList: {
      handler() {
        if (this.procChangeList.length === 0) {
          this.isProcDeleted = false;
        }
      },
      immediate: true,
    },
    processCheckBoxChecked() {
      this.loadStore();
    },
  },
  methods: {
    /**
     * [setStatusAliveFormatter 동작상태]
     * @author {Yang}
     * @param  {[type]} row [description]
     */
    statusAliveFormatter(value) {
      if (isNil(value)) { return EMPTY_TEXT; }
      switch (value) {
        case '0' : return '다운상태';
        case '1' : return '정상';
        default: return EMPTY_TEXT;
      }
    },
    getStatusAliveClass(value) {
      if (value === '0') {
        return 'state-abnormal';
      } else if (value === '1') {
        return 'state-normal';
      }
      return '';
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    openPopup() {
      this.$refs.realtimeControlSlidingPopup.open();
      this.loadProcessOverloadSettings();
      if (this.$refs.majorTable === undefined) {
        this.$nextTick(() => {
          this.loadStore();
        });
      } else {
        this.loadStore();
      }
    },
    close() {
      this.$refs.realtimeControlSlidingPopup.close();
    },
    onChangeProcessCheckBox(value) {
      this.processCheckBoxChecked = [];
      this.processCheckBoxChecked.push(value);
    },
    /**
     * [loadStore 프로세스 리스트 로드]
     * @author {Yang}
     * @return {[type]} [description]
     */
    loadStore() {
      const me = this;
      me.majorDatas = [];
      me.totalDatas = [];
      me.zombieList = [];

      const params = {
        objId: this.selectedNode.obj.objId,
      };

      let isZombieProc = false;
      if (this.processCheckBoxChecked[0] === 'procTotalCount') {
        params.conditionId = 'procTotalCount';
      } else {
        params.conditionId = 'procZombieCount';
        isZombieProc = true;
      }
      serverTableInfoAPI.getServerProcess(params).then((response) => {
        const result = response.data;
        if (result.success === true && !isNil(result.data)) {
          const data = result.data;
          me.majorDatas = data.major;
          if (isZombieProc) {
            me.zombieList = data.realtime;
          } else {
            me.totalDatas = data.realtime;
          }
        } else {
          me.majorDatas = [];
          if (isZombieProc) {
            me.zombieList = [];
          } else {
            me.totalDatas = [];
          }
        }
      }).catch(() => {
        me.majorDatas = [];
        if (isZombieProc) {
          me.zombieList = [];
        } else {
          me.totalDatas = [];
        }
      });
    },
    loadProcessOverloadSettings() {
      serverTableInfoAPI.getProcessOverloadSettings(this.selectedNode.obj.objId).then((response) => {
        if (response.data.success === true) {
          this.popoverOligopolyForm = response.data.data;
        }
      });
    },
    majorloadStore() {
      const tableParams = this.$refs.majorTable.getParameter();
      const params = {
        objId: this.selectedNode.obj.objId,
        ...tableParams,
      };
      serverTableInfoAPI.getServerRealtimeMajorControlList(params)
        .then((result) => {
          if (result.data.success) {
            this.majorDatas = result.data.data;
            this.majorTotal = result.data.total;
          }
        });
    },
    /**
     * [processMajorBgcolor table row에 major 데이터 색상삽입]
     * @author {Yang}
     * @param  {[type]} row      [description]
     * @param  {[type]} rowIndex [description]
     * @return {[String]}        [major data insert bgcolor]
     */
    processMajorBgcolor({ row }) {
      if (isTrue(row.procFlag)) {
        return 'point-import';
      }
      return '';
    },
    /**
     * [onClickExecuteServerStartMajorProcess 프로세스 시작 실행]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onClickExecuteServerStartMajorProcess(row) {
      serverTableInfoAPI.executeServerStartMajorProcess({ serverId: row.serverId, processCommandStart: row.processCommandStart, procName: row.procName })
        .then((result) => {
          if (result.data.success) {
            this.majorloadStore();
            this.successNotification('프로세스 시작 명령어');
          } else {
            this.failureNotification('프로세스 시작 명령어');
          }
        });
    },
    /**
     * [onClickExecuteServerStopMajorProcess 프로세스 중지 실행]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onClickExecuteServerStopMajorProcess(row) {
      serverTableInfoAPI.executeServerStopMajorProcess({ serverId: row.serverId, processCommandStop: row.processCommandStop, procName: row.procName })
        .then((result) => {
          if (result.data.success === true) {
            this.majorloadStore();
            this.successNotification('프로세스 중지 명령어');
          } else {
            this.failureNotification('프로세스 중지 명령어');
          }
        });
    },
    /**
     * [isProcessCommand 프로세스 명령어 여부]
     * @author {Yang}
     * @param  {[type]}  value [description]
     * @return {Boolean}       [description]
     */
    isProcessCommand(value) {
      return !isEmpty(value);
    },
    /**
     * [successNotification 수행완료 notify]
     * @author {Yang}
     * @param  {[type]} title [description]
     * @return {[type]}       [description]
     */
    successNotification(title) {
      this.$notify({
        title,
        customClass: 'center',
        message: `${this.objInfo.obj.objName}에 대한 ${title}를 실행하였습니다.`,
        duration: 2000,
      });
    },
    /**
     * [failureNotification 수행실패 nodify]
     * @author {Yang}
     * @param  {[type]} title [description]
     * @return {[type]}       [description]
     */
    failureNotification(title) {
      this.$notify({
        title,
        customClass: 'center',
        message: `${this.objInfo.obj.objName}에 대한 ${title}를 실행하지 못했습니다..`,
        duration: 2000,
      });
    },
    getConvertValuByUnit(value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'KB', true, false, true);
    },
    killProcess() {
      this.$confirm('프로세스를 종료 하시겠습니까?', '종료', {
        confirmButtonText: '종료',
        cancelButtonText: '취소',
      }).then(() => {
        if (!isNil(this.procChangeList)) {
          this.loading = true;
          serverTableInfoAPI.killProcess(this.procChangeList).then((response) => {
            if (response.data.success) {
              this.loading = false;
              if (response.data.data) {
                this.$message(msgUtil.getCustomMsgData('프로세스 종료를 성공하였습니다.'));
                this.loadStore();
              } else {
                this.$message(msgUtil.getCustomMsgData('프로세스 종료를 실패하였습니다.'));
                this.loadStore();
              }
            }
          });
        }
      });
    },
    formatterForProcCount(row, column, value) {
      return isNil(value) ? 0 : value;
    },
    procChangeSelection(selectVal) {
      let majorFlag = true;
      selectVal.forEach((item) => {
        if (isTrue(item.procFlag)) {
          majorFlag = false;
        }
      });
      this.isProcDeleted = majorFlag;
      this.procChangeList = selectVal;
    },
    onFormSubmitPopoverOligopoly(value) {
      this.popoverOligopolyForm = {};
      this.popoverOligopolyForm.processMaxCpuLimit = value.processMaxCpuLimit;
      this.popoverOligopolyForm.processMaxMemLimit = value.processMaxMemLimit;
    },
    /**
     * [progressbarBgcolor cpu의 limit 판단 메서드/ 프로그래스바 색깔 변경]
     * @author {Yang}
     * @param  {[type]} procCpuUserate [cpu 값]
     * @return {[type]}                [color]
     */
    progressbarBgcolor(procCpuUserate) {
      if (!isNil(this.popoverOligopolyForm.processMaxCpuLimit) && procCpuUserate >= this.popoverOligopolyForm.processMaxCpuLimit) {
        return 'abnormal';
      }
      return '';
    },
    /**
     * [progressbarBgcolor momory의 limit 판단 메서드/ 글씨 색깔 변경]
     * @author {Yang}
     * @param  {[type]} procCpuUserate [momory 값]
     * @return {[type]}                [color]
     */
    memoryTextColor(processMaxMemlimit) {
      if (!isNil(this.popoverOligopolyForm.processMaxMemLimit) && processMaxMemlimit > (this.popoverOligopolyForm.processMaxMemLimit * 1024)) {
        return 'red';
      }
      return 'black';
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/ServerRealtimeControlPopup.vue